// Utilitaires de performance pour PRIVIA YACHTS

// Debounce pour les recherches
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Throttle pour les événements de scroll
export const throttle = (func, limit) => {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

// Préchargement d'images
export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

// Batch de préchargement d'images
export const preloadImages = async (urls, maxConcurrent = 3) => {
  const results = [];
  for (let i = 0; i < urls.length; i += maxConcurrent) {
    const batch = urls.slice(i, i + maxConcurrent);
    const batchPromises = batch.map(url => preloadImage(url).catch(() => null));
    const batchResults = await Promise.all(batchPromises);
    results.push(...batchResults);
  }
  return results;
};

// Configuration de performance
export const PERFORMANCE_CONFIG = {
  CACHE_DURATION: 5 * 60 * 1000, // 5 minutes
  DEBOUNCE_DELAY: 300, // 300ms pour les recherches
  THROTTLE_DELAY: 100, // 100ms pour le scroll
  LAZY_LOAD_THRESHOLD: 0.1, // 10% visible pour déclencher le chargement
  MAX_CONCURRENT_IMAGES: 3, // Maximum 3 images en parallèle
  PAGINATION_SIZE: 60 // 60 yachts par page
};
